// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.header-panel {
    z-index: 99 !important;
    position: fixed;
    top: 0px;
    left: 0px;
    background-color: var(--headerBackground);
    color: var(--headerColor);
    height: 36px;
    width: 200px;
}

.header-right {
    z-index: 99 !important;
    position: fixed;
    top: 0px;
    right: 0px;
    background-color: var(--headerBackground);
    color: var(--headerColor);
    height: 36px;
    width: 120px;
}

.header-help {
    float: right;
    height: 36px;
    width: 36px;
    margin-right: 20px;
}

.header-theme {
    float: right;
    height: 36px;
    width: 36px;
    margin-right: 5px;
}

.main-btn {
    height: 34px;
    width: 34px;
    min-width: unset !important;
    padding:unset !important;
    line-height: 34px;
    margin-left: 5px;
    margin-right: 5px;
  }
  
  .main-btn mat-icon {
    font-size: 24px;
    height: unset;
    width: unset;
  }

.header-menu {
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2); 
}

.header-icon {
    padding: 0 14px;
}

.menu-separator {
    border-top-color: rgba(0,0,0,0.2);
}

::ng-deep .mat-menu-item {
    font-size: 11px;
    height: 30px !important;
    line-height: unset !important;
  }`, "",{"version":3,"sources":["webpack://./src/app/header/header.component.css"],"names":[],"mappings":";AACA;IACI,sBAAsB;IACtB,eAAe;IACf,QAAQ;IACR,SAAS;IACT,yCAAyC;IACzC,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,QAAQ;IACR,UAAU;IACV,yCAAyC;IACzC,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,YAAY;EACd;;AAEF;IACI,sGAAsG;AAC1G;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,6BAA6B;EAC/B","sourcesContent":["\n.header-panel {\n    z-index: 99 !important;\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    background-color: var(--headerBackground);\n    color: var(--headerColor);\n    height: 36px;\n    width: 200px;\n}\n\n.header-right {\n    z-index: 99 !important;\n    position: fixed;\n    top: 0px;\n    right: 0px;\n    background-color: var(--headerBackground);\n    color: var(--headerColor);\n    height: 36px;\n    width: 120px;\n}\n\n.header-help {\n    float: right;\n    height: 36px;\n    width: 36px;\n    margin-right: 20px;\n}\n\n.header-theme {\n    float: right;\n    height: 36px;\n    width: 36px;\n    margin-right: 5px;\n}\n\n.main-btn {\n    height: 34px;\n    width: 34px;\n    min-width: unset !important;\n    padding:unset !important;\n    line-height: 34px;\n    margin-left: 5px;\n    margin-right: 5px;\n  }\n  \n  .main-btn mat-icon {\n    font-size: 24px;\n    height: unset;\n    width: unset;\n  }\n\n.header-menu {\n    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2); \n}\n\n.header-icon {\n    padding: 0 14px;\n}\n\n.menu-separator {\n    border-top-color: rgba(0,0,0,0.2);\n}\n\n::ng-deep .mat-menu-item {\n    font-size: 11px;\n    height: 30px !important;\n    line-height: unset !important;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
